app.initializers.add('serakoi/flarum-hideprofile', () => {
  console.log('[serakoi/flarum-hideprofile] Hello, forum!');
});
